export const initModal = () => {
  const modal = document.getElementById('alertModal');
  const trigger = document.querySelector('.js-online-shop');
  const closeBtn = modal?.querySelector('.alert-close');

  if (!modal || !trigger) return;

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    modal.showModal();
  });

  closeBtn?.addEventListener('click', () => {
    modal.close();
  });

  // 背景クリックで閉じる
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.close();
    }
  });
};
